import styled from "styled-components";

export const StyledContainer = styled.div`
  position: absolute;
  width: 100vw;
  padding: 0 1rem 0 1rem;
`;

